export default "__VITE_ASSET__Dh0$$MeO__"